import { useEffect, useRef, useState } from 'react';
import { HINTS, type HintKey } from 'shared';

/**
 * Пояснение к полю: кружок со знаком вопроса рядом с подписью.
 *
 * Текст показывается всплывающим слоем **поверх** содержимого, а не
 * вставкой в поток. Раньше он вставлялся прямо внутрь `<label>`, и
 * нажатие на знак вопроса раздвигало форму: поле уезжало вниз вместе со
 * всем, что под ним, а на узком поле сам знак не помещался в строку с
 * подписью и переносился отдельной строкой, сдвигая поле относительно
 * соседей ещё до всякого нажатия.
 *
 * Наведением слой не открывается: на телефоне наведения нет, а нажатие
 * работает одинаково везде. Закрывается повторным нажатием, щелчком мимо
 * и клавишей Escape — все три способа человек пробует не задумываясь.
 */
export default function Hint({ k }: { k: HintKey }) {
  const [open, setOpen] = useState(false);
  const box = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!open) return;

    const away = (e: MouseEvent) => {
      if (!box.current?.contains(e.target as Node)) setOpen(false);
    };
    const esc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', away);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', away);
      document.removeEventListener('keydown', esc);
    };
  }, [open]);

  return (
    <span className="hint" ref={box}>
      <button
        type="button"
        className="hint__btn"
        aria-label="Пояснение"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        ?
      </button>
      {open && (
        <span className="hint__pop" role="note">
          {HINTS[k]}
        </span>
      )}
    </span>
  );
}
